export default {
  buttons: {
    go_to_basket: 'Go to Basket',
  },
};
